module.exports = __webpack_public_path__ + "img/26_8.a55709b5.png";